import React, { lazy } from 'react';

const LearningModuleForm = lazy( () => import( './components/LearningModuleForm' ) );
const LearningModuleList = lazy( () => import( './components/LearningModuleList' ) );

// Wrapper function for the component that gets rendered, is passed additional props from the outer arrow function?
const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

export const routes = [
    {
        title: 'Learning Record Studio',
        pattern: '/:companyId',
        render: ( props ) => <LearningModuleList { ...props }/>,
    },
    {
        title: 'Add/Edit Learning Module',
        pattern: '/:companyId/detail/:id?',
        render: ( props ) => <LearningModuleForm { ...props }/>
    }
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    // destructuring match property out of next route
    const { match } = nextRoute;
    // if match exists, nothing has been rendered yet, and if the component isn't undefined
    if ( match && !match.render && typeof match.component !== 'undefined' ) {
        // we set the render property to the result of our bundle function. We pass it the component we want rendered, and it's corresponding props
        match.render = Bundle( match.component, match.props );
        action.ok();
    } else {
        action.ok();
    }
}
